import React from 'react';
import Count from '../../common/count';
import image from "../../../assets/img/page/cta.jpg";
import icon from "../../../assets/img/icon/star-dark.svg";
import content from "../../../assets/img/shape/content-1.png";

const TextSlide = () => {
    return (
        <div className="text__slide">
        </div>
    );
};

export default TextSlide;